import React from 'react';

import Footer from '../components/Footer';
import '../App.css';

const CrewManningSupply = () => {
  return (
    <div>
      

      {/* Cover Section */}
      <div className="service-cover">
        <img src="/images/crew.webp" alt="Crew Manning & Supply" className="service-cover-image" />
        <div className="service-cover-text">
          <h1>Crew Manning & Supply</h1>
          <p>Certified Personnel | Global Standards | Reliable Deployment</p>
        </div>
      </div>

      {/* Main Content */}
      <section className="service-section container">
        <div className="intro-text">
          <h2>Trusted Crew for Global Operations</h2>
          <p>
            BlueWaves Ship Management (PVT) LTD delivers specialized crew manning and supply services for commercial fleets, offshore platforms, and specialized vessels. 
            We connect our clients with highly qualified, STCW-certified seafarers who are ready to perform with excellence.
          </p>
          <p>
            Our vast pool of competent maritime professionals is selected through a rigorous screening and training process to ensure safety, compliance, and performance at sea.
          </p>
        </div>

        {/* Services Offered */}
        <div className="service-grid">
          <div className="service-card">
            <img src="/images/recrutiment.webp" alt="Crew Recruitment" className="service-card-image" />
            <div className="service-card-content">
              <h3>Crew Selection & Recruitment</h3>
              <ul>
                <li>Screening, background verification & certification</li>
                <li>Officer and rating deployment based on vessel type</li>
                <li>Maritime English & technical skill evaluation</li>
              </ul>
            </div>
          </div>

          <div className="service-card">
            <img src="/images/crew-logistic.webp" alt="Crew Logistics" className="service-card-image" />
            <div className="service-card-content">
              <h3>Logistics & Mobilization</h3>
              <ul>
                <li>Visa processing & flight arrangements</li>
                <li>Onboarding & safety briefing</li>
                <li>Port agent coordination worldwide</li>
              </ul>
            </div>
          </div>

          <div className="service-card">
            <img src="/images/crew-tranning.webp" alt="Training & Compliance" className="service-card-image" />
            <div className="service-card-content">
              <h3>Training & Compliance</h3>
              <ul>
                <li>STCW & Flag State compliance</li>
                <li>Emergency drills, bridge/machine room simulators</li>
                <li>Behavioral, leadership, and safety culture training</li>
              </ul>
            </div>
          </div>

          <div className="service-card">
            <img src="/images/crew-welfear.webp" alt="Crew Welfare" className="service-card-image" />
            <div className="service-card-content">
              <h3>Crew Welfare & Retention</h3>
              <ul>
                <li>24/7 support hotline for seafarers</li>
                <li>Retention programs & loyalty rewards</li>
                <li>Healthcare, insurance & mental wellness support</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default CrewManningSupply;
